import {IRecordHistoryBiochemists} from './record-history-biochemists.interface';
import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BaseService, DataBaseServiceResponse} from '../../services/base-service/base.service';

export interface IRRecordHistoryBiochemists {
  recordHistoryBiochemists: IRecordHistoryBiochemists;
  wasDeployed?: boolean;
}

export namespace RecordBiochemistAction {
  export class GetActive {
    static readonly type = '[Record] Get Record History Biochemists Action';
    constructor(public serviceId: string, public patientId: string) { }
  }

  export class PatchActive {
    static readonly type = '[Record] Patch Record History Biochemists  Action';
    constructor(public serviceId: string, public patientId: string, public environmentAffectivity: IRecordHistoryBiochemists) { }
  }

  export class Deploy {
    static readonly type = '[Record] Was Deployed History Biochemists Action';
    constructor(public value: boolean) { }
  }
}

@State<IRRecordHistoryBiochemists>({
  name: 'RecordHistoryBiochemistsState',
  defaults: {
    recordHistoryBiochemists: null
  },
})

@Injectable()
export class RecordHistoryBiochemistsState {
  constructor(
    private baseService: BaseService<any>,
  ) {
  }
  url = environment.SERVER_URL;

  @Selector()
  public static getRecordHistoryBiochemists(state: IRRecordHistoryBiochemists): IRecordHistoryBiochemists {
    return state.recordHistoryBiochemists;
  }

  @Selector()
  public static getWasDeployed(state: IRRecordHistoryBiochemists): boolean {
    return state.wasDeployed;
  }

  @Action(RecordBiochemistAction.GetActive)
  async getRecordHistoryBiochemistsAction(
    ctx: StateContext<IRRecordHistoryBiochemists>,
    action: RecordBiochemistAction.GetActive
  ): Promise<void> {
    const response: DataBaseServiceResponse<IRecordHistoryBiochemists> = await firstValueFrom(
      this.baseService.get(`${this.url}/patients/${action.patientId}/service/${action.serviceId}/records/biochemical/active`)
    );
    if (response.error) throw new Error(response.message);

    ctx.patchState({
      recordHistoryBiochemists: response.entity
    });
  }

  @Action(RecordBiochemistAction.PatchActive)
  async patchRecordHistoryBiochemistsAction(
    ctx: StateContext<IRRecordHistoryBiochemists>,
    action: RecordBiochemistAction.PatchActive
  ): Promise<void> {
    const response: DataBaseServiceResponse<void> = await firstValueFrom(
      this.baseService.patch(`${this.url}/patients/${action.patientId}/service/${action.serviceId}/records/biochemical`, action.environmentAffectivity)
    );

    if (response.error) throw new Error(response.message);
  }

  @Action(RecordBiochemistAction.Deploy)
  async wasDeployedRecordHistoryBiochemistsAction(
    ctx: StateContext<IRRecordHistoryBiochemists>,
    action: RecordBiochemistAction.Deploy
  ): Promise<void> {
    ctx.patchState({
      wasDeployed: action.value
    });
  }
}
